import { Link } from 'react-router-dom';
import AnimeCard from '@/components/base/AnimeCard';
import { animeList } from '@/mocks/anime';

export default function FeaturedSection() {
  const featured = animeList.filter((a) => a.isRecommended).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑部精心挑选的高分佳作</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {featured.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>

        <Link
          to="/category"
          className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-600 font-medium"
        >
          查看全部精选
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}